module.exports = [{"id":1,"modality":"modalidad-i","value":"Verificar la información, ya que la información está incompleta y/o es errónea"},{"id":2,"modality":"modalidad-i","value":"Firmar la solicitud de participación"},{"id":3,"modality":"modalidad-i","value":"Escanear de manera correcta la solicitud"},{"id":4,"modality":"modalidad-i","value":"Adjuntar la solicitud de participación"},{"id":5,"modality":"modalidad-i","value":"Ninguno"}]


//////////////////
// WEBPACK FOOTER
// ./src/elements/revision/widget/participation_request_revision.json
// module id = 697
// module chunks = 0